<template>
  <Cleave
    v-model="input"
    :options="options"
    :disabled="disabled"
    :class="['form-control', ...classNames]"
  />
</template>

<script>
export default {
  props: {
    value: [String, Number],
    disabled: [Boolean],
    classNames: {
      type: Array,
      default: () => ([]),
    },
  },

  data () {
    return {
      input: null,
    }
  },

  computed: {
    options () {
      const shop_info = this.auth.shop_info
      const settings = shop_info.settings
      const appearance = settings.general.appearance
      const format_number = appearance.format_number
      const place = format_number.decimal.place
      const use_comma = format_number.use_comma
      return {
        numeral: true,
        numeralDecimalScale: place,
        delimiter: use_comma ? ',' : '',
      }
    },
  },

  watch: {
    input (newVal, oldVal) {
      this.$emit('input', this.input)
      if ((newVal === '' && oldVal === null) || (oldVal === '' && newVal === null)) {

      } else if (newVal !== oldVal) {
        this.$emit('change', this.input)
      }
    },
    value () {
      this.input = this.value
    },
  },

  created () {
    this.input = this.value
  },
}
</script>



// WEBPACK FOOTER //
// src/components/base/BaseInputNumber.vue